import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "warningCircleFilled"
const WarningCircleFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M12 1.5C17.799 1.5 22.5 6.201 22.5 12S17.799 22.5 12 22.5 1.5 17.799 1.5 12 6.201 1.5 12 1.5M12 15.375C11.172 15.375 10.5 16.047 10.5 16.875S11.172 18.375 12 18.375 13.5 17.703 13.5 16.875 12.828 15.375 12 15.375M10.875 5.625V13.875H13.125V5.625z"
            clipRule="evenodd"
          />
          <path
            fillRule="evenodd"
            d="M12 1.5C17.799 1.5 22.5 6.201 22.5 12S17.799 22.5 12 22.5 1.5 17.799 1.5 12 6.201 1.5 12 1.5M12 15.375C11.172 15.375 10.5 16.047 10.5 16.875S11.172 18.375 12 18.375 13.5 17.703 13.5 16.875 12.828 15.375 12 15.375M10.875 5.625V13.875H13.125V5.625z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default WarningCircleFilledIcon
